
import { defineComponent } from "vue";
import QRCodeVue3 from "qrcode-vue3";

export default defineComponent({
  name: "qr-view-modal",
  components: {
    QRCodeVue3,
  },
  props: {
    url: String,
  },
  setup() {
    return {};
  },
});
